import { api, type PaginatedResponse } from './client';

export interface OutboxSummary {
  pending: number;
  processing: number;
  processed: number;
  failed: number;
  dead: number;
  oldest_pending_age_seconds: number | null;
}

export interface OutboxEvent {
  id: string;
  event_type: string;
  payload: Record<string, unknown>;
  status: string;
  correlation_id: string | null;
  dedupe_key: string | null;
  retry_count: number;
  last_error: string | null;
  created_at: string;
  claimed_at: string | null;
  processed_at: string | null;
  next_attempt_at: string | null;
  duration_seconds: number | null;
}

export type OutboxEventListResponse = PaginatedResponse<OutboxEvent>;

export interface OutboxEventsParams {
  status_filter?: string;
  event_type?: string;
  search?: string;
  created_after?: string;
  page?: number;
  page_size?: number;
}

export async function fetchOutboxSummary(): Promise<OutboxSummary> {
  const { data } = await api.get<OutboxSummary>('/admin/outbox/summary');
  return data;
}

export async function fetchOutboxEvents(params: OutboxEventsParams): Promise<OutboxEventListResponse> {
  const { data } = await api.get<OutboxEventListResponse>('/admin/outbox/events', { params });
  return data;
}

export async function fetchOutboxEventTypes(): Promise<string[]> {
  const { data } = await api.get<string[]>('/admin/outbox/event-types');
  return data;
}

export async function reprocessOutboxEvent(eventId: string): Promise<void> {
  await api.post(`/admin/outbox/events/${eventId}/reprocess`);
}
